import _ from 'underscore';

import { Users } from '../../../userManagement/services/resources/Users';
import { IUser } from '../../../ts/ServerApi/types/IUser';
import { spaceContentsUpdateOwners, UpdateOwnerData } from '../../actions/spaces/RequestSpaceContentsActions';
import { getAppStore } from '../../AppStore';
import { ServiceLocator } from '../../ServiceLocator';
import { ICollectionInfo } from './ICollectionInfo';
import { setSpaceInfoItem } from '../../actions/spaces/EnterSpaceAction';
import { SpaceInfo } from '../../state/SpaceInfo';

export type CollectionsOwnerCacheSpace = 'collection' | 'collections';

export interface CollectionOwnerCache {
  readonly updateCollectionOwners: (collections: ICollectionInfo[], spaceType: CollectionsOwnerCacheSpace) => void;
}

export function initCollectionOwnerCache(): CollectionOwnerCache {

  const collectionOwners: _.Dictionary<IUser> = {};
  const updateStore = (collections: ICollectionInfo[], spaceType: CollectionsOwnerCacheSpace) => {
    if (spaceType === 'collections') {
      // remove this with FeatureFlags.CollectionsGA
      const collectionUpdateOwnerData: UpdateOwnerData[] = collections.map((collection) => {
        return {
          contentId: collection.id,
          ownerId: collection.userId,
          contentType: collection.contentType
        };
      });
      getAppStore().dispatch(spaceContentsUpdateOwners(collectionOwners, collectionUpdateOwnerData));

    } else if (spaceType === 'collection') {
      // keep this even after removing FeatureFlags.CollectionsGA
      const updatedItem: ICollectionInfo = {
        ...collections[0],
        owner: collectionOwners[collections[0].userId]
      };
      const spaceInfo: SpaceInfo = {
        spaceType: 'collection',
        item: updatedItem,
        subspaceName: undefined
      };

      getAppStore().dispatch(setSpaceInfoItem(spaceInfo));
    }
  };

  return {
    updateCollectionOwners: (collections: ICollectionInfo[], spaceType: CollectionsOwnerCacheSpace) => {
      let userIds = collections.map((value) => value.userId);
      userIds = _.filter(userIds, (ownerId, idx) => {
        return userIds.indexOf(ownerId) === idx
        && !_.has(collectionOwners, ownerId);
      });

      if (userIds.length > 0) {
        Users.instance.getUsersById(userIds).then((usersResponse) => {
          usersResponse.items.forEach((user) => {
            collectionOwners[user.id] = user;
          });
          updateStore(collections, spaceType);
        });
      } else {
        updateStore(collections, spaceType);
      }
    }
  };
}

export const collectionOwnerCache = initCollectionOwnerCache();
